import { IDestroyOptions, Sprite } from "pixi.js";
import { ButtonWithScaleAndPosYAnimation } from "../../common/components/ButtonWithScaleAndPosYAnimation";
import { GameResourcePackage } from "../resources/GameResourcePackage";
import { CommonResourcesPackage } from "../../common/resources/CommonResourcesPackage";

export class MarketplaceButton extends ButtonWithScaleAndPosYAnimation {
    private readonly gameResources: GameResourcePackage;

    private light: Sprite;
    private dotIconSprite: Sprite;

    public constructor(gameResources: GameResourcePackage, commonResources: CommonResourcesPackage) {
        super(gameResources.assets_views_game_ui_marketplace_button_news_button_png);
        this.gameResources = gameResources;
        this.onUp.add(this.clickHandle, this);

        const houseIcon = new Sprite(commonResources.assets_common_ui_vector_png);
        houseIcon.position.set((this.defaultView.width - houseIcon.width) * 0.5 + 2, (this.defaultView.height - houseIcon.height) * 0.5 - 3);
        this.defaultView.addChild(houseIcon);
        this.dotIconSprite = new Sprite(commonResources.assets_common_ui_indicator_point_png);
        this.dotIconSprite.position.set(-10, -this.dotIconSprite.height * 0.5 + 5);
        this.defaultView.addChild(this.dotIconSprite);
        this.dotIconSprite.visible = false;
        this.light = new Sprite(this.gameResources.assets_views_game_ui_marketplace_button_light_white_png);
        this.light.position.set((this.defaultView.width - this.light.width) * 0.5, this.defaultView.height - this.light.height * 0.5 + 16);
        this.addChild(this.light);
    }

    private async clickHandle(): Promise<void> {
        this.dotIconSprite.visible = false;
        this.light.texture = this.gameResources.assets_views_game_ui_marketplace_button_light_white_png;
    }

    public showDot(): void {
        this.visible = true;
        this.dotIconSprite.visible = true;
        this.light.texture = this.gameResources.assets_views_game_ui_building_button_light_red_png;
    }

    public override destroy(options?: boolean | IDestroyOptions): void {
        this.onUp.remove(this.clickHandle, this);
        super.destroy(options);
    }
}
